import module from './module'
/* Config */
import './config.js'
/* Run */
import './run.js'
/* Styles */
import './styles/--cursor/style.scss'
import './styles/--margin/style.scss'
import './styles/--opacity/style.scss'
import './styles/--text/style.scss'
import './styles/kd-animate-height/directive.js'
import './styles/kd-badge/style.scss'
import './styles/kd-blackboard/style.scss'
import './styles/kd-button/style.scss'
import './styles/kd-card/style.scss'
import './styles/kd-control/style.scss'
import './styles/kd-dialog/style.scss'
import './styles/kd-fieldset/style.scss'
import './styles/kd-hoverable/directive.js'
import './styles/kd-icon/style.scss'
import './styles/kd-id/style.scss'
import './styles/kd-input/style.scss'
import './styles/kd-item/style.scss'
import './styles/kd-link/style.scss'
import './styles/kd-ripple/directive'
import './styles/kd-sticky/style.scss'
import './styles/kd-tabs/style.scss'
import './styles/kd-toolbar/style.scss'
import './styles/root/style.scss'
/* Components */
import './components/kd-alert/component.js'
import './components/kd-checkbox/component.js'
import './components/kd-content/component.js'
import './components/kd-control/component.js'
import './components/kd-dialog/component.js'
import './components/kd-dialog-actions/component.js'
import './components/kd-dialog-title/component.js'
import './components/kd-loader/component.js'
import './components/kd-paper/component.js'
import './components/kd-progress/component.js'
import './components/kd-progress-circular/component.js'
import './components/kd-repeater/component.js'
import './components/kd-switch/component.js'
import './components/kd-table/component.js'
import './components/kd-topbar/component.js'
/* Directives */
import './directives/kd-autofocus/directive.js'
import './directives/kd-await/directive.js'
import './directives/kd-backdrop/directive.js'
import './directives/kd-input/directive.js'
import './directives/kd-input-autogrow/directive.js'
import './directives/kd-modal/directive.js'
import './directives/kd-stick/directive.js'
import './directives/kd-while/directive.js'
/* Services */
import './services/KdBackdrop.js'
import './services/KdBreadcrumbs.js'
import './services/KdElementModal.js'
import './services/KdElementScrollClip.js'
import './services/KdElementStick.js'
import './services/KdHttpInterceptor.js'
import './services/KdLoadIndicator.js'
import './services/KdNotify.js'
import './services/KdTaskRunner.js'

export default module.name



// WEBPACK FOOTER //
// ./src/kendu/ui/index.js